<ng-template #monthView let-modal>
	<div class="modal-header">
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
			<i class="fa fa-close"></i>
		</button>
	</div>
	<div class="modal-body">
		<ng-container *ngIf="datepicked">
			<app-sales-calendar [initialDate]="datepicked"></app-sales-calendar>
		</ng-container>
	</div>
	<div class="modal-footer"></div>
</ng-template>

<div class="tol-wrap" [ngStyle]="themeVars">
	<div class="tol-icon-badge">
		<i class="material-icons">table_chart</i>
	</div>

	<div class="tol-header">
		<div class="tol-title-group">
			<span class="tol-title">Units This/Last</span>
			<span class="tol-subtitle">This Over Last</span>
		</div>

		<div class="tol-actions">
			<label class="tol-years-label">Years:</label>
			<input
				type="number"
				class="tol-years-input"
				[(ngModel)]="yearCount"
				(ngModelChange)="loadData()"
				min="1" />
			<button class="tol-icon-btn" *ngIf="canEditTargets" (click)="openTargetEditor()" title="Set sales targets">
				<i class="material-icons">flag</i>
			</button>
			<button class="tol-icon-btn" (click)="loadData()" [disabled]="loading" title="Refresh">
				<i class="material-icons">refresh</i>
			</button>
			<button class="tol-icon-btn" (click)="exportXls()" [disabled]="!thisoverlast" title="Export Excel">
				<i class="fa fa-file-excel-o"></i>
			</button>
			<button class="tol-icon-btn" (click)="exportPdf()" [disabled]="!thisoverlast" title="Export PDF">
				<i class="fa fa-file-pdf-o"></i>
			</button>
		</div>
	</div>

	<div class="tol-stats" *ngIf="thisoverlast && !loading">
		<div class="tol-stat tol-stat--wide">
			<span class="tol-stat-val">
				{{ thisoverlast.mtd_units | number:'1.0-0' }} / {{ thisoverlast.mtdlast_units | number:'1.0-0' }}
				<span class="tol-pct" [ngClass]="unitsPctClass">
					<i class="fa" [ngClass]="thisoverlast.percent_updown_units > 0 ? 'fa-long-arrow-up' : 'fa-long-arrow-down'"></i>
					{{ thisoverlast.percent_updown_units | percent:'1.0-0' }}
				</span>
			</span>
			<span class="tol-stat-lbl">Units MTD / MTDL</span>
		</div>
		<div class="tol-stat tol-stat--wide">
			<span class="tol-stat-val">
				{{ thisoverlast.mtd_dollars | currency }} / {{ thisoverlast.mtdlast_dollars | currency }}
				<span class="tol-pct" [ngClass]="salesPctClass">
					<i class="fa" [ngClass]="thisoverlast.percent_updown_dollars > 0 ? 'fa-long-arrow-up' : 'fa-long-arrow-down'"></i>
					{{ thisoverlast.percent_updown_dollars | percent:'1.0-0' }}
				</span>
			</span>
			<span class="tol-stat-lbl">Sales MTD / MTDL</span>
		</div>
		<div class="tol-stat tol-stat--wide" *ngIf="mtdTarget > 0">
			<span class="tol-stat-val">
				{{ mtdTarget | currency }}
				<span class="tol-pct" [ngClass]="mtdTargetAttainment >= 1 ? 'text-success' : 'text-danger'">
					{{ mtdTargetAttainment | percent:'1.0-0' }}
				</span>
			</span>
			<span class="tol-stat-lbl">Month Target / Attained</span>
		</div>
	</div>

	<div class="tol-loading" *ngIf="loading || !thisoverlast">
		<svg class="spinner" width="35" height="35" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
			<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
		</svg>
	</div>

	<ng-template #trendChips let-trends>
		<div class="tol-trends">
			<span class="tol-chip" *ngFor="let t of trends" [ngClass]="'tol-chip--' + t.dir">
				<i class="fa" *ngIf="t.dir !== 'flat'" [ngClass]="t.dir === 'up' ? 'fa-long-arrow-up' : 'fa-long-arrow-down'"></i>
				{{ t.key }} {{ t.pct | percent:'1.0-0' }}
			</span>
		</div>
	</ng-template>

	<div #print_table class="tol-table-wrap" *ngIf="thisoverlast && !loading">
		<table class="tol-table-combined">
			<thead>
				<tr>
					<th class="tol-col-year"></th>
					<th class="tol-col-metric"></th>
					<th class="tol-col-ttl">TTL</th>
					<th *ngFor="let label of monthLabels">{{ label }}</th>
				</tr>
			</thead>
			<tbody>
				<ng-container *ngFor="let year of thisoverlast.years; let i = index">
					<tr class="tol-row-qty">
						<td class="tol-year-cell" [attr.rowspan]="yearHasTargets(year) ? 3 : 2">{{ year.qty?.[0]?.year || year.sales?.[0]?.year }}</td>
						<td class="tol-metric-cell">Qty</td>
						<td class="tol-ttl-cell">{{ getQtyTotalYear(year) | number:'1.0-0' }}</td>
						<td class="tol-num-cell" *ngFor="let month of year.qty">
							<span class="tol-num tol-num--link" (click)="viewHistory(month.monthnumber, month.year)">{{ month.value | number:'1.0-0' }}</span>
							<ng-container *ngIf="monthTrends(month.label, year, i) as trends">
								<ng-container *ngTemplateOutlet="trendChips; context: { $implicit: trends }"></ng-container>
							</ng-container>
						</td>
					</tr>
					<tr class="tol-row-sale">
						<td class="tol-metric-cell">Sale</td>
						<td class="tol-ttl-cell" [class.tol-neg]="getSaleTotalYear(year) < 0">{{ getSaleTotalYear(year) | currency }}</td>
						<td class="tol-num-cell" [class.tol-neg]="month.value < 0" *ngFor="let month of year.sales">{{ month.value | currency }}</td>
					</tr>
					<tr class="tol-row-target" *ngIf="yearHasTargets(year)">
						<td class="tol-metric-cell">Target</td>
						<td class="tol-ttl-cell">{{ yearTargetTotal(year) | currency }}</td>
						<td class="tol-num-cell" *ngFor="let month of year.sales">
							<ng-container *ngIf="targetFor(month.year, month.monthnumber) as target; else noTarget">
								<span class="tol-num">{{ target | currency }}</span>
								<span class="tol-chip" *ngIf="attainmentFor(month) as attained"
									[ngClass]="attained >= 1 ? 'tol-chip--up' : 'tol-chip--down'">
									{{ attained | percent:'1.0-0' }}
								</span>
							</ng-container>
							<ng-template #noTarget><span class="tol-num tol-muted">—</span></ng-template>
						</td>
					</tr>
				</ng-container>
			</tbody>
		</table>
	</div>
</div>
